import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as queryString from 'query-string';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

class NgxDeeplinkerService {
    constructor() { }
    getSourceUrl() {
        return window.location.origin + window.location.pathname;
    }
    handleDeeplinkClick(config) {
        const urlTokens = this.getUrlTokens();
        let formTokens = this.getFormTokens();
        const appParams = { ...urlTokens };
        let hops = {};
        formTokens.source = this.getSourceUrl();
        formTokens.idToPopulate = config.idToPopulate || '';
        formTokens = queryString.stringify(formTokens);
        if (urlTokens.hops) {
            hops = queryString.parse(urlTokens.hops, { arrayFormat: 'bracket' });
        }
        if (hops.hops && hops.hops.length > 0) {
            hops.hops.push(config.appPrefix);
        }
        else {
            hops = { hops: [config.appPrefix] };
        }
        appParams[config.appPrefix] = formTokens;
        appParams['appPrefix'] = config.appPrefix;
        appParams['hops'] = queryString.stringify(hops, { arrayFormat: 'bracket' });
        const deeplinkUrl = this.createDeeplinkUrl(appParams, config.destinationUrl, config.additionalQueryParams);
        this.navigateTo(deeplinkUrl);
    }
    getReturnData(appPrefix) {
        if (appPrefix) {
            const urlTokens = this.getUrlTokens();
            const returnData = queryString.parse(urlTokens[appPrefix]);
            return typeof (returnData) === 'object' ? returnData : {};
        }
        return {};
    }
    getFormTokens() {
        const elements = document.querySelectorAll('[data-url-persist]');
        const formFields = {};
        for (let fieldIndex = 0; fieldIndex < elements.length; fieldIndex++) {
            formFields[elements[fieldIndex].id] = elements[fieldIndex].value;
        }
        return formFields;
    }
    getUrlTokens() {
        const urlQueryParams = window.location.search;
        return queryString.parse(urlQueryParams);
    }
    createDeeplinkUrl(params, destinationUrl, additionalQueryParams) {
        const allParams = { ...params, ...additionalQueryParams };
        const allParamsString = queryString.stringify(allParams);
        return `${destinationUrl}?${allParamsString}`;
    }
    navigateTo(url) {
        document.location.href = url;
    }
    returnHandler(options) {
        let hops = {};
        const urlTokens = this.getUrlTokens();
        if (urlTokens.hops) {
            hops = queryString.parse(urlTokens.hops, { arrayFormat: 'bracket' });
        }
        if (this.shouldSubmit(hops)) {
            this.handleReturn(hops, options);
        }
        else {
            return;
        }
    }
    handleReturn(hops, options) {
        const urlTokens = this.getUrlTokens();
        const currentApp = hops.hops.pop();
        const originTokens = queryString.parse(urlTokens[currentApp]);
        urlTokens.hops = queryString.stringify(hops, { arrayFormat: 'bracket' });
        if (options.callbackValue) {
            originTokens[originTokens.idToPopulate] = options.callbackValue;
        }
        urlTokens[currentApp] = queryString.stringify(originTokens);
        urlTokens.appPrefix = currentApp;
        if (urlTokens[options.appPrefix]) {
            delete urlTokens[options.appPrefix];
        }
        const deeplinkUrl = this.createDeeplinkUrl(urlTokens, originTokens.source, options.additionalQueryParams);
        this.navigateTo(deeplinkUrl);
    }
    shouldSubmit(hops) {
        return hops.hops && hops.hops.length > 0;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class DeeplinkerConfig {
    appPrefix;
    destinationUrl;
    idToPopulate;
    displayLabel;
    callbackValue;
    additionalQueryParams;
    constructor(appPrefix, destinationUrl, idToPopulate, displayLabel, callbackValue, additionalQueryParams) {
        this.appPrefix = appPrefix;
        this.destinationUrl = destinationUrl;
        this.idToPopulate = idToPopulate;
        this.displayLabel = displayLabel;
        this.callbackValue = callbackValue;
        this.additionalQueryParams = additionalQueryParams;
    }
}

class NgxDeeplinkerComponent {
    ngxDeepLinkerService;
    _config = new DeeplinkerConfig();
    set config(config) {
        this._config = config;
    }
    get config() {
        return this._config;
    }
    constructor(ngxDeepLinkerService) {
        this.ngxDeepLinkerService = ngxDeepLinkerService;
    }
    ngOnInit() { }
    handleDeeplinkClick(e) {
        e.preventDefault();
        this.ngxDeepLinkerService.handleDeeplinkClick(this.config);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerComponent, deps: [{ token: NgxDeeplinkerService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: NgxDeeplinkerComponent, selector: "lib-ngx-deeplinker", inputs: { config: "config" }, ngImport: i0, template: `
      <ng-container *ngIf="config.appPrefix && config.destinationUrl && config.idToPopulate && config.displayLabel">
          <button class="x-btn-secondary" (click)="handleDeeplinkClick($event)"
          >{{config.displayLabel}}</button>
      </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-ngx-deeplinker', template: `
      <ng-container *ngIf="config.appPrefix && config.destinationUrl && config.idToPopulate && config.displayLabel">
          <button class="x-btn-secondary" (click)="handleDeeplinkClick($event)"
          >{{config.displayLabel}}</button>
      </ng-container>
  ` }]
        }], ctorParameters: function () { return [{ type: NgxDeeplinkerService }]; }, propDecorators: { config: [{
                type: Input
            }] } });

class NgxDeeplinkerModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerModule, declarations: [NgxDeeplinkerComponent], imports: [CommonModule], exports: [NgxDeeplinkerComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerModule, providers: [NgxDeeplinkerService], imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDeeplinkerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [NgxDeeplinkerService],
                    declarations: [
                        NgxDeeplinkerComponent
                    ],
                    exports: [
                        NgxDeeplinkerComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of ngx-deeplinker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxDeeplinkerComponent, NgxDeeplinkerModule, NgxDeeplinkerService };
